// Rinnova collezione — il click sulla foto della card apre l'occhiata veloce del
// tema (quick add modal) invece di portare alla scheda prodotto. Titolo, badge e
// pulsante "Aggiungi" restano invariati.
class RinnovaCollectionGrid extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onMediaClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onMediaClick);
  }

  onMediaClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const media = event.target.closest('[data-rinnova-quick-view]');
    if (!media || !this.contains(media)) return;

    // Apertura in nuova scheda/finestra: lasciamo fare al browser.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;

    const quickAdd = media.closest('product-card')?.querySelector('quick-add-component');
    if (!quickAdd || typeof quickAdd.handleClick !== 'function') return;

    // Senza quick-add-component (o senza JS del tema) il link resta valido e
    // porta alla scheda prodotto: qui invece apriamo il modale.
    event.preventDefault();
    quickAdd.handleClick(event);
  };
}

if (!customElements.get('rinnova-collection-grid')) {
  customElements.define('rinnova-collection-grid', RinnovaCollectionGrid);
}
